'use no memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import ImportCsv from '@/features/import-csv';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { useEquipmentTableRows } from './-hooks/useEquipmentTableRows';

// Search schema for query params
const SearchSchema = z.object({
  page: z.number().optional(),
  pageSize: z.number().optional(),
  pageIndex: z.number().optional().default(0),
  uploadedFileKey: z.string().optional(),
  processingState: z.string().optional()
});
type SearchParams = z.infer<typeof SearchSchema>;
const EquipmentImportCsv = () => {
  const searchParams = Route.useSearch() as SearchParams;
  const search = {
    ...searchParams,
    pageIndex: searchParams.pageIndex ?? 0,
    pageSize: searchParams.pageSize ?? 100
  } as const;
  const navigate = Route.useNavigate();
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.equipment.importCsv'
  });
  const {
    t: tCompleteDialog
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.equipment.importCsv.completeDialog'
  });
  const title = t('title');
  const exportApiUrl = '/v2/equipment-csv';
  const exportFilename = 'equipment';
  const unit = t('unit');
  return <ImportCsv baseLink="/equipment/import-csv" baseTitle={title} exportApiUrl={exportApiUrl} exportFilename={exportFilename} downloadOptions={[{
    mode: 'edit-template',
    label: t('prepareCsvFile.templateTitle')
  }, {
    mode: 'edit',
    label: t('prepareCsvFile.updateExisting')
  }]} completeLinkButton={tCompleteDialog('button')} completeLinkUrl="/equipment" unit={unit} search={search} navigate={navigate} useTableRows={useEquipmentTableRows} />;
};
export const Route = createFileRoute('/_staff/equipment/import-csv/')({
  component: EquipmentImportCsv,
  validateSearch: zodValidator(SearchSchema)
});